import { render, staticRenderFns } from "./TelegramContactList.vue?vue&type=template&id=4fe52e02&scoped=true"
import script from "./TelegramContactList.vue?vue&type=script&lang=js"
export * from "./TelegramContactList.vue?vue&type=script&lang=js"
import style0 from "./TelegramContactList.vue?vue&type=style&index=0&id=4fe52e02&prod&lang=scss"
import style1 from "./TelegramContactList.vue?vue&type=style&index=1&id=4fe52e02&prod&scoped=true&lang=scss"
import style2 from "./TelegramContactList.vue?vue&type=style&index=2&id=4fe52e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe52e02",
  null
  
)

export default component.exports